<template>
	<div class="content">
		<div class="content-assets">
			<div class="flex-cement">
				<img src="@/assets/contact_slices/Group 1162@2x (1).png" style="width: 16px; height: 15px" />
				<div class="cement">联系我们</div>
			</div>
			<div class="border-top"></div>
			<div>
				<ul class="ulGrop">
					<li>联系电话：400-696-5550</li>
					<li>联系邮箱：jingkashou@163.com </li>
					<li>公司地址: 辽宁省大连市中山区桃仙街</li>
				</ul>
			</div>
			<div style="display: flex; align-items: center; margin-left: 30px;">
				<div>
					<img src="@/assets/Home_slices1/WechatIMG198.png" style="width: 104px; height: 104px;"/>
					<div class="title-align">微信小程序</div>
				</div>
				<!-- <div>
					<img src="@/assets/Home_slices1/sjhazh.png" style="width: 104px; height: 104px;"/>
					<div class="title-align">App下载</div>
				</div> -->
			</div>
		</div>
	</div>
</template>

<script></script>

<style lang="scss" scoped>
.content-assets {
	padding: 20px 21px;
	padding-: 26px;
}

.content {
	width: 85%;
	background-color: #fff;
	margin-left: 20px;
	margin-left: auto;
}

.flex-cement {
	position: relative;
	display: flex;
	align-items: center;

	.cement {
		font-family: PingFang SC, PingFang SC;
		font-weight: 600;
		font-size: 20px;
		color: #333333;
		margin-left: 8px;
		font-style: normal;
		text-transform: none;
	}
}

.flex-contact-slices {
	position: absolute;
	top: 0;
	right: 0;
	display: flex;
	align-items: center;
}

.assets-return {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #333333;
	font-style: normal;
	text-transform: none;
	margin-left: 4px;
	margin-top: 2px;
}

.border-top {
	width: 99%;
	height: 0px;
	border-top: 1px solid #eeeeee;
	margin-top: 16px;
	padding-top: 16px;
}

.flex-const-slice {
	display: flex;
	margin-top: 10px;
}
.title-slice {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 18px;
	color: #333333;
	text-align: left;
	font-style: normal;
	text-transform: none;
	margin-top: 2px;
}

.title-slice1 {
	color: #ff2f17;
}

.december {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 17px;
	color: #aaaaaa;
	font-style: normal;
	text-transform: none;
	margin-left: 5px;
	margin-top: -2px;
}

.flex-top {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.ulGrop{
	li{
		// width: 263px;
		height: 30px;
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 16px;
		color: #333333;
		line-height: 30px;
		text-align: left;
		font-style: normal;
		text-transform: none;
	}
}
.title-align{
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #333333;
	line-height: 16px;
	text-align: center;
	font-style: normal;
	text-transform: none;
}
</style>
